import { render, staticRenderFns } from "./TransactionsTableMobile.vue?vue&type=template&id=25beaa22&scoped=true"
import script from "./TransactionsTableMobile.vue?vue&type=script&lang=js"
export * from "./TransactionsTableMobile.vue?vue&type=script&lang=js"
import style0 from "./TransactionsTableMobile.vue?vue&type=style&index=0&id=25beaa22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25beaa22",
  null
  
)

export default component.exports